import Vue from 'vue';

import VueEventHub from '@lib/vue-event-hub';

Vue.use(VueEventHub);

export { EventHub as default } from '@lib/vue-event-hub';
